import React from 'react';
import ReactDOM from 'react-dom';
import { SwedishCompanyFormToggler } from './components/forms/swedish-company-form-toggler';
import './main.scss';
import { ProviderWithGlobalStore } from 'tradera/state/configure-store';
import { bootLanguages } from 'tradera/lang/boot-languages';
import { UserRegWrapper } from 'tradera/apps/registration/components/common/user-reg-wrapper';

bootLanguages();

const root = ReactDOM.createRoot(document.getElementById('app-form'));
root.render(
    <ProviderWithGlobalStore>
        <UserRegWrapper>
            <SwedishCompanyFormToggler
                antiForgeryToken={window.injectAppProps.antiForgeryToken}
            />
        </UserRegWrapper>
    </ProviderWithGlobalStore>
);
